import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { contentService } from '../services/api';

const FloatingWhatsApp = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('85261871388');

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await contentService.get();
      if (response.data?.whatsapp) {
        // Remove any non-digit characters
        const cleanNumber = response.data.whatsapp.replace(/\D/g, '');
        setWhatsappNumber(cleanNumber);
      }
    } catch (error) {
      console.error('Error fetching WhatsApp number:', error);
    }
  };

  const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}`;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-6 py-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110"
        style={{
          backgroundColor: '#25D366',
          animation: 'pulse 2s infinite'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* WhatsApp Icon */}
        <div className="relative">
          <MessageCircle className="h-8 w-8 text-white" fill="white" />
          {/* Notification Dot */}
          <span
            className="absolute -top-1 -right-1 h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FF4444' }}
          />
        </div>

        {/* Text (shows on hover for desktop, always visible on mobile) */}
        <span
          className={`text-white font-semibold text-lg whitespace-nowrap transition-all duration-300 ${
            isHovered ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 md:opacity-0 md:max-w-0'
          } overflow-hidden`}
        >
          WhatsApp 查詢
        </span>
      </a>

      {/* Pulse Animation */}
      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          50% {
            box-shadow: 0 0 0 20px rgba(37, 211, 102, 0);
          }
        }

        /* Breathing animation */
        @keyframes breathe {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </>
  );
};

export default FloatingWhatsApp;
